<template>
  <b-card no-body>
    <b-card-header>
      <h3 class="mb-0">Active Devices</h3>
    </b-card-header>
    <b-card-body style="max-height: 500px; overflow-y: auto;">
      <b-list-group flush>
        <b-list-group-item
          v-for="device in activeDevicesList"
          :key="device.device_id"
          class="border-0"
        >
          <b-row align-v="center">
            <b-col>
              <h5 class="mb-1">{{ device.device_id }}</h5>
              <p class="text-sm mb-0">
                <i class="fas fa-user-nurse mr-1"></i>{{ device.assigned_to }}
              </p>
              <small class="text-muted">Group: {{ device.group || 'N/A' }}</small>
            </b-col>
            <b-col cols="auto">
              <b-badge variant="info" pill>Monitoring</b-badge>
              <small class="text-muted d-block">{{ formatTimeAgo(device.last_activity) }}</small>
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
      <div v-if="activeDevicesList.length === 0" class="text-center py-5">
        <i class="fas fa-mobile-alt fa-3x text-muted mb-3"></i>
        <p class="text-muted">No active devices</p>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: 'ActiveDevices',
  props: {
    activeDevicesList: {
      type: Array,
      default: () => []
    },
    formatTimeAgo: {
      type: Function,
      required: true
    }
  }
}
</script>